import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "../../contexts/AuthContext";
import { IDSButton, IDSAccordion, IDSRadio, IDSAlert } from "@inera/ids-react";
import { getUserForms } from "../../services/E2EAPI";

function FormSelector() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [forms, setForms] = useState([]);
  const [selectedForm, setSelectedForm] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchForms = async () => {
      try {
        const data = await getUserForms();
        setForms(data);
      } catch (error) {
        console.error("Error fetching forms:", error);
        setError("Kunde inte hämta formulärlistan. Försök ladda om sidan eller kontakta support.");
      } finally {
        setLoading(false);
      }
    };

    if (isAuthenticated) {
      fetchForms();
    }
  }, [isAuthenticated]);

  // Split into 1177 groups and other groups
  const grouped1177 = {};
  const groupedOther = {};

  forms.forEach((form) => {
    const key = (form.description || "Övrigt").trim();
    if (key.toLowerCase().startsWith("1177")) {
      if (!grouped1177[key]) grouped1177[key] = [];
      grouped1177[key].push(form);
    } else {
      if (!groupedOther[key]) groupedOther[key] = [];
      groupedOther[key].push(form);
    }
  });

  const renderRadios = (formList) => (
    <div>
      {formList.map((form) => (
        <div key={form.formId} className="ids-mb-2">
          <IDSRadio
            name="form-selection"
            value={form.formId}
            checked={selectedForm === form.formId}
            onChange={() => setSelectedForm(form.formId)}
          >
            {form.formTitle} v{form.version}
          </IDSRadio>
        </div>
      ))}
    </div>
  );

  const handleOpenForm = () => {
    if (!selectedForm) return;
    navigate(`/e2e/tester/forms/${selectedForm}`);
  };

  if (loading) {
    return <div>Laddar formulär...</div>;
  }

  if (error) {
    return (
      <div className="ids-m-6">
        <main className="ids-content ids-p-6" style={{ maxWidth: "1200px", margin: "2rem auto" }}>
          <IDSAlert type="error">
            <p>{error}</p>
          </IDSAlert>
        </main>
      </div>
    );
  }

  if (!forms || forms.length === 0) {
    return <div>Inga formulär hittades.</div>;
  }

  return (
    <div className="ids-m-6">
      <main className="ids-content ids-p-6" style={{ maxWidth: "1200px", margin: "2rem auto" }}>
        <h2 className="ids-heading-l ids-mb-2">Välj E2E Underlag</h2>
        <p className="ids-mb-6">Välj en tjänst och sedan det formulär du vill fylla i.</p>

        <div className="ids-mb-6">

          {/* 1177 parent accordion */}
          {Object.keys(grouped1177).length > 0 && (
            <IDSAccordion
              headline={<h2>1177 Tjänster</h2>}
              headlineSize="m"
              level={1}
            >
              {Object.keys(grouped1177).map((groupKey) => (
                <IDSAccordion
                  key={groupKey}
                  headline={<h3>{groupKey}</h3>}
                  headlineSize="s"
                  level={2}
                >
                  {renderRadios(grouped1177[groupKey])}
                </IDSAccordion>
              ))}
            </IDSAccordion>
          )}

          {/* Other groups flat */}
          {Object.keys(groupedOther).map((groupKey) => (
            <IDSAccordion
              key={groupKey}
              headline={<h2>{groupKey}</h2>}
              headlineSize="m"
              level={1}
            >
              {renderRadios(groupedOther[groupKey])}
            </IDSAccordion>
          ))}

        </div>

        <IDSButton size="m" type="button" onClick={handleOpenForm} disabled={!selectedForm}>
          Öppna formulär
        </IDSButton>
      </main>
    </div>
  );
}

export default FormSelector;
